<table class="facturation-overview-table">
  <tr class="header-row">
    <th class="id">Jobnr</th>
    <th class="date">Aanvraag</th>
    <th class="description">Omschrijving</th>
    <th class="price">
      <div class="d-flex justify-content-end">
        <span>Prijs</span>
        <mat-icon
          class="price-warning-icon"
          *ngIf="atLeastOneNonStandardPrice"
          matTooltip="Er is minstens één component zonder standaard prijs. De prijs van zulke componenten wordt hier niet getoond."
          >report_problem</mat-icon
        >
      </div>
    </th>
  </tr>
  <ng-container *ngFor="let product of project.products; let first = first">
    <ng-container *ngIf="product.type === CLIENT_WINDOW_STICKER_TYPE">
      <ng-container
        *ngTemplateOutlet="
          windowSticker;
          context: {
            windowSticker: product,
            project: project,
            baseProject: baseProject,
            first: first
          }
        "
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="product.type === PRODUCT_TYPES.WINDOWSTICKER.value">
      <ng-container
        *ngTemplateOutlet="
          standardWindowSticker;
          context: {
            standardWindowSticker: product,
            project: project,
            baseProject: baseProject,
            first: first
          }
        "
      ></ng-container>
    </ng-container>
    <ng-container
      *ngIf="product.type === PRODUCT_TYPES.CUSTOMWINDOWSTICKER.value"
    >
      <ng-container
        *ngTemplateOutlet="
          customWindowSticker;
          context: {
            customWindowSticker: product,
            project: project,
            baseProject: baseProject,
            first: first
          }
        "
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="product.type === PRODUCT_TYPES.BOARD.value">
      <ng-container
        *ngTemplateOutlet="
          board;
          context: {
            board: product,
            project: project,
            baseProject: baseProject,
            first: first
          }
        "
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="product.type === PRODUCT_TYPES.OTHER_PRODUCT.value">
      <ng-container
        *ngTemplateOutlet="
          otherProduct;
          context: {
            otherProduct: product,
            project: project,
            baseProject: baseProject,
            first: first
          }
        "
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="product.type === PRODUCT_TYPES.IP_BOARD.value">
      <ng-container
        *ngTemplateOutlet="
          ipBoard;
          context: {
            ipBoard: product,
            project: project,
            baseProject: baseProject,
            first: first
          }
        "
      ></ng-container>
    </ng-container>
  </ng-container>
</table>

<!-- WINDOWSTICKER -->
<ng-template
  #windowSticker
  let-windowSticker="windowSticker"
  let-project="project"
  let-baseProject="baseProject"
  let-first="first"
>
  <tr>
    <td class="id accent">
      <span *ngIf="first">{{ project.id | or }}</span>
    </td>
    <td class="date">
      <span *ngIf="first">{{ createdDate | date : 'dd.MM.yyyy' }}</span>
    </td>
    <td class="description">
      <div
        *ngFor="
          let stickerPart of windowSticker.clientStickerParts;
          let f = first
        "
        class="product-description"
      >
        <span [class.hidden]="!f"
          >{{ windowSticker.calculatedTypeLabel }},</span
        >
        <span
          >&nbsp;{{
            stickerPart.partType ===
            CLIENT_STICKER_PART_TYPE.STANDARD_STICKER_PART
              ? (stickerPart.instance?.productSize?.height
                | joiner
                  : ' H x '
                  : stickerPart.instance?.productSize?.width + ' W')
              : stickerPart.partType === CLIENT_STICKER_PART_TYPE.STICKER_PART
              ? (stickerPart.instance?.stickerHeight
                | joiner : ' H x ' : stickerPart.instance?.stickerWidth + ' W')
              : '-'
          }}</span
        >
      </div>
      <div
        class="address"
        *ngIf="first && baseProject.projectPlacement?.address != null"
      >
        {{
          baseProject.projectPlacement.address.line1
            | printAddress
              : baseProject.projectPlacement.address.postalCode
              : baseProject.projectPlacement.address.city
        }}
      </div>
    </td>
    <td class="price">
      {{
        windowSticker.calculatedPriceDisplay | asFormatDecimal : true : 2 | or
      }}
      €
    </td>
  </tr>
</ng-template>

<!-- STANDARD WINDOWSTICKER -->
<ng-template
  #standardWindowSticker
  let-standardWindowSticker="standardWindowSticker"
  let-project="project"
  let-baseProject="baseProject"
  let-first="first"
>
  <tr>
    <td class="id accent">
      <span *ngIf="first">{{ project.id | or }}</span>
    </td>
    <td class="date">
      <span *ngIf="first">{{ createdDate | date : 'dd.MM.yyyy' }}</span>
    </td>
    <td class="description">
      <div
        *ngFor="
          let stickerPart of standardWindowSticker.standardStickerParts
            | filterArrayPredicate : productSizeFilter;
          let f = first
        "
        class="product-description"
      >
        <span [class.hidden]="!f"
          >{{ standardWindowSticker.calculatedTypeLabel }},</span
        >
        <span
          >&nbsp;{{
            stickerPart.productSize.height
              | joiner : ' H x ' : stickerPart.productSize.width + ' W'
          }}</span
        >
      </div>
      <div
        class="address"
        *ngIf="first && baseProject.projectPlacement?.address != null"
      >
        {{
          baseProject.projectPlacement.address.line1
            | printAddress
              : baseProject.projectPlacement.address.postalCode
              : baseProject.projectPlacement.address.city
        }}
      </div>
    </td>
    <td class="price">
      <ng-container
        *ngIf="
          !client || baseProject.id == null;
          else clientStandardWindowStickerPrice
        "
      >
        {{
          (standardWindowSticker.standardStickerParts
          | reduce : reduceStandardWindowStickerPlacementPrice
          | nullCheck)
            ? (standardWindowSticker.standardStickerParts
              | reduce : reduceStandardWindowStickerPlacementPrice
              | sum
                : (windowSticker.standardStickerParts
                    | reduce : reduceStandardWindowStickerPlacementPrice)
              | asFormatDecimal : true : 2)
            : (standardWindowSticker.standardStickerParts
              | reduce : reduceStandardWindowStickerPlacementPrice
              | nullCheck)
            ? (standardWindowSticker.standardStickerParts
              | reduce : reduceStandardWindowStickerPlacementPrice
              | asFormatDecimal : true : 2)
            : '-'
        }}
        €
      </ng-container>
      <ng-template #clientStandardWindowStickerPrice>
        {{
          (standardWindowSticker.productionPrice | nullCheck)
            ? (standardWindowSticker.productionPrice
              | sum : standardWindowSticker.placementPrice
              | asFormatDecimal : true : 2)
            : (standardWindowSticker.productionPrice | nullCheck)
            ? (standardWindowSticker.productionPrice
              | asFormatDecimal : true : 2)
            : '-'
        }}
        €
      </ng-template>
    </td>
  </tr>
</ng-template>

<!-- CUSTOM WINDOWSTICKER -->
<ng-template
  #customWindowSticker
  let-customWindowSticker="customWindowSticker"
  let-project="project"
  let-baseProject="baseProject"
  let-first="first"
>
  <tr>
    <td class="id accent">
      <span *ngIf="first">{{ project.id | or }}</span>
    </td>
    <td class="date">
      <span *ngIf="first">{{ createdDate | date : 'dd.MM.yyyy' }}</span>
    </td>
    <td class="description">
      <div
        *ngFor="
          let stickerPart of customWindowSticker.standardStickerParts;
          let f = first
        "
        class="product-description"
      >
        <span [class.hidden]="f"
          >{{ standardWindowSticker.calculatedTypeLabel }},</span
        >
        <span
          >&nbsp;{{
            stickerPart.stickerHeight
              | joiner : ' H x ' : stickerPart.stickerWidth + ' W'
          }}</span
        >
      </div>
      <div
        class="address"
        *ngIf="first && baseProject.projectPlacement?.address != null"
      >
        {{
          baseProject.projectPlacement.address.line1
            | printAddress
              : baseProject.projectPlacement.address.postalCode
              : baseProject.projectPlacement.address.city
        }}
      </div>
    </td>
    <td class="price">
      {{
        (customWindowSticker.productionPrice | nullCheck)
          ? (customWindowSticker.productionPrice
            | sum : customWindowSticker.placementPrice
            | asFormatDecimal : true : 2)
          : (customWindowSticker.productionPrice | nullCheck)
          ? (customWindowSticker.productionPrice | asFormatDecimal : true : 2)
          : (customWindowSticker.price | nullCheck)
          ? (customWindowSticker.price | asFormatDecimal : true : 2)
          : '-'
      }}
      €
    </td>
  </tr>
</ng-template>

<!-- BOARD -->
<ng-template
  #board
  let-board="board"
  let-project="project"
  let-baseProject="baseProject"
  let-first="first"
>
  <tr>
    <td class="id accent">
      <span *ngIf="first">{{ project.id | or }}</span>
    </td>
    <td class="date">
      <span *ngIf="first">{{ createdDate | date : 'dd.MM.yyyy' }}</span>
    </td>
    <td class="description">
      <div
        *ngFor="let part of board.boardParts; let f = first"
        class="product-description"
      >
        <span [class.hidden]="!f"
          >{{
            part.boardType?.label
              | joiner : ' ' : (part.placementType?.label | lowercase)
          }},</span
        >
        <span
          >&nbsp;{{ part.height | joiner : ' H x ' : part.width + ' W' }}</span
        >
      </div>
      <div
        class="address"
        *ngIf="first && baseProject.projectPlacement?.address != null"
      >
        {{
          baseProject.projectPlacement.address.line1
            | printAddress
              : baseProject.projectPlacement.address.postalCode
              : baseProject.projectPlacement.address.city
        }}
      </div>
    </td>
    <td class="price">
      <ng-container
        *ngIf="!client || baseProject.id == null; else boardProductionPrice"
      >
        {{ board.calculatedAggregatePrice | asFormatDecimal : true : 2 | or }}
        €
      </ng-container>
      <ng-template #boardProductionPrice>
        {{
          (board.productionPrice | nullCheck)
            ? (board.productionPrice
              | sum : board.placementPrice
              | asFormatDecimal : true : 2)
            : (board.placementPrice | nullCheck)
            ? (board.placementPrice | asFormatDecimal : true : 2)
            : '-'
        }}
        €
      </ng-template>
    </td>
  </tr>
  <tr
    *ngIf="
      (board.boardParts | reduce : reduceBoardPaintedPostsPrice | nullCheck) ||
      (client && (board.paintedPostPrice | nullCheck)) ||
      (board.calculatedPaintedPostsPrice | nullCheck)
    "
  >
    <td class="id"></td>
    <td class="date"></td>
    <td class="description">+ Geschilderde constructie</td>
    <td class="price">
      <ng-container
        *ngIf="!client || baseProject.id == null; else boardPaintedPostPrice"
      >
        {{
          board.calculatedPaintedPostsPrice | asFormatDecimal : true : 2 | or
        }}
        €
      </ng-container>
      <ng-template #boardPaintedPostPrice>
        {{
          (board.paintedPostPrice | nullCheck)
            ? (board.paintedPostPrice | asFormatDecimal : true : 2)
            : '-'
        }}
        €
      </ng-template>
    </td>
  </tr>
  <ng-container *ngFor="let otherPriceLine of otherPriceLines">
    <tr
      *ngIf="
        otherPriceLine?.text?.length > 0 && (otherPriceLine.price | nullCheck)
      "
    >
      <td class="id"></td>
      <td class="date"></td>
      <td class="description">{{ otherPriceLine.text }}</td>
      <td class="price">
        {{ otherPriceLine.price | asFormatDecimal : true : 2 }} €
      </td>
    </tr>
  </ng-container>
</ng-template>

<!-- OTHER -->
<ng-template
  #otherProduct
  let-otherProduct="otherProduct"
  let-project="project"
  let-baseProject="baseProject"
  let-first="first"
>
  <tr>
    <td class="id accent">
      <span *ngIf="first">{{ project.id | or }}</span>
    </td>
    <td class="date">
      <span *ngIf="first">{{ createdDate | date : 'dd.MM.yyyy' }}</span>
    </td>
    <td class="description">
      <div class="product-description">
        <span>{{ otherProduct.otherProductName | or : 'Andere' }},</span>
        <span
          >&nbsp;{{
            otherProduct.height
              | joiner : ' H x ' : otherProduct.width + ' W'
              | or : '-'
          }}</span
        >
      </div>
      <div
        class="address"
        *ngIf="first && baseProject.projectPlacement?.address != null"
      >
        {{
          baseProject.projectPlacement.address.line1
            | printAddress
              : baseProject.projectPlacement.address.postalCode
              : baseProject.projectPlacement.address.city
        }}
      </div>
    </td>
    <td class="price">
      {{
        (otherProduct.productionPrice | nullCheck)
          ? (otherProduct.productionPrice
            | sum : otherProduct.placementPrice
            | asFormatDecimal : true : 2)
          : (otherProduct.placementPrice | nullCheck)
          ? (otherProduct.placementPrice | asFormatDecimal : true : 2)
          : '-'
      }}
      €
    </td>
  </tr>
</ng-template>

<!-- IPBOARD -->
<ng-template
  #ipBoard
  let-ipBoard="ipBoard"
  let-project="project"
  let-baseProject="baseProject"
  let-first="first"
>
  <tr>
    <td class="id">
      <ng-container *ngIf="first">
        <div class="accent">{{ project.id | or }}</div>
        <div
          *ngIf="project.oldPlatformId != null"
          class="font-italic"
          [matTooltip]="'Jobnummer oud platform'"
        >
          ({{ project.oldPlatformId }})
        </div>
      </ng-container>
    </td>
    <td class="date">
      <span *ngIf="first">{{ createdDate | date : 'dd.MM.yyyy' }}</span>
    </td>
    <td class="description">
      <div *ngIf="collaborativeCompanyNames?.length > 0">
        Gezamenlijk bord: {{ collaborativeCompanyNames }}
      </div>
      <div class="product-description">
        <ng-container
          *ngIf="
            ipBoard.boardPart?.boardType?.ordinal ===
              BOARD_TYPE_CHOICES.DIVERGENT.ordinal;
            else regularBoardType
          "
        >
          {{
            BOARD_TYPE_CHOICES.DIVERGENT.label
              | joiner : ' - ' : ipBoard.boardPart.divergentBoardType
          }}
        </ng-container>
        <ng-template #regularBoardType>
          {{
            ipBoard.boardPart?.sign?.type?.value ===
              SIGN_TYPE_CHOICES.STICKER.value ||
            ipBoard.boardPart?.otherIPBoardPartType?.ordinal ===
              IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
              ? 'Kleefbord'
              : (ipBoard.boardPart?.boardType?.label
                | joiner
                  : ' - '
                  : (ipBoard.boardPart.placementType?.ordinal
                      | ipBoardPlacementTypeOrAlternative
                        : ipBoard.boardPart.placementType?.label
                        : ipBoard.boardPart.alternativePlacementType
                        : 'Andere plaatsingsmethode'
                      | shortenText : 50))
          }},
          {{
            ipBoard.boardPart?.sign?.type?.value ===
              SIGN_TYPE_CHOICES.STICKER.value ||
              ipBoard.boardPart?.otherIPBoardPartType?.ordinal ===
                IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
              | formatIPBoardDimensions
                : ipBoard.boardPart?.sign?.signMeasurements?.height
                : ipBoard.boardPart?.sign?.signMeasurements?.width
                : ipBoard.boardPart?.sign?.shape?.value ===
                    SIGN_SHAPE_TYPE_CHOICES.UPRIGHT.value
                : ipBoard.boardPart?.otherHeight
                : ipBoard.boardPart?.otherWidth
          }}
        </ng-template>
      </div>
      <div
        class="address"
        *ngIf="first && baseProject.projectPlacement?.address != null"
      >
        {{
          baseProject.projectPlacement.address.line1
            | printAddress
              : baseProject.projectPlacement.address.postalCode
              : baseProject.projectPlacement.address.city
        }}
      </div>
    </td>
    <td
      *ngIf="
        !divergentPricesOnly &&
          !baseProject.invoiceAsNonExecuted &&
          !project.collaborative;
        else emptyPrice
      "
      [ngClass]="
        collaborativeCompanyNames?.length > 0
          ? 'all-width vertical-align-middle'
          : 'price'
      "
    >
      <span *ngIf="!client || !project.collaborative">
        {{
          (ipBoardPlacementPrice | nullCheck)
            ? (ipBoardPlacementPrice
              | multiply : distinctCompanyFactor
              | asFormatDecimal : true : 2)
            : '-'
        }}
        €
      </span>
    </td>
  </tr>
  <tr
    *ngIf="
      !divergentPricesOnly &&
      !baseProject.invoiceAsNonExecuted &&
      first &&
      (ipBoardProductionPrice | nullCheck)
    "
  >
    <td class="id"></td>
    <td class="date"></td>
    <td class="description">Aanmaak</td>
    <td class="price">
      {{
        ipBoardProductionPrice
          | multiply : distinctCompanyFactor
          | asFormatDecimal : true : 2
      }}
      €
    </td>
  </tr>
  <tr
    *ngIf="
      !divergentPricesOnly &&
      !baseProject.invoiceAsNonExecuted &&
      client &&
      project.collaborative &&
      (ipBoardProductionPrice | nullCheck)
    "
  >
    <td class="id"></td>
    <td class="date"></td>
    <td class="description">Aanmaakkost</td>
    <td class="price">
      {{
        ipBoardProductionPrice
          | multiply : distinctCompanyFactor
          | asFormatDecimal : true : 2
      }}
      €
    </td>
  </tr>
  <ng-container *ngIf="!ipBoard.leftRightBoard; else leftRightBoardRows">
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Tekst:
        {{
        ipBoard.text != null ? ipBoard.text : ipBoard.boardPart?.customText
      }}"
      [price]="ipBoardTextPrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Titel: {{ ipBoard.boardPart?.titleAdjustment?.title }}"
      [price]="ipBoardOneSideStockTitlePrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Titel: {{
        ipBoard.boardPart?.otherTitleAdjustment?.title
      }}"
      [price]="ipBoardOtherSideStockTitlePrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Aangepaste titel"
      [price]="ipBoardCustomTitlePrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Telnr: {{
        ipBoard.boardPart?.phoneNumberAdjustment?.phoneNumber
      }}"
      [price]="ipBoardOneSideStockPhoneNumberPrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Telnr: {{
        ipBoard.boardPart?.otherPhoneNumberAdjustment?.phoneNumber
      }}"
      [price]="ipBoardOtherSideStockPhoneNumberPrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Aangepaste telefoonnummer"
      [price]="ipBoardCustomPhoneNumberPrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Sticker: {{ ipBoard.boardPart?.sticker?.text }}"
      [price]="ipBoardStockStickerPrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Aangepaste sticker"
      [price]="ipBoardCustomStickerPrice"
    ></tr>
  </ng-container>
  <ng-template #leftRightBoardRows>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Tekst{{
        (ipBoardOtherSideTextPrice | nullCheck) ? ' links' : ''
      }}:
        {{ ipBoard.boardPart?.customText }}"
      [price]="ipBoardTextPrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Tekst{{ (ipBoardTextPrice | nullCheck) ? ' rechts' : '' }}:
        {{ ipBoard.otherSideBoardPart?.customText }}"
      [price]="ipBoardOtherSideTextPrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Titel: {{ ipBoard.boardPart?.titleAdjustment?.title }}"
      [price]="ipBoardOneSideStockTitlePrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Titel: {{
        ipBoard.otherSideBoardPart?.titleAdjustment?.title
      }}"
      [price]="ipBoardOtherSideStockTitlePrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Aangepaste titel"
      [price]="ipBoardCustomTitlePrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Telnr: {{
        ipBoard.boardPart?.phoneNumberAdjustment?.phoneNumber
      }}"
      [price]="ipBoardOneSideStockPhoneNumberPrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Telnr: {{
        ipBoard.otherSideBoardPart?.phoneNumberAdjustment?.phoneNumber
      }}"
      [price]="ipBoardOtherSideStockPhoneNumberPrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Aangepaste telefoonnummer"
      [price]="ipBoardCustomPhoneNumberPrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Sticker: {{ ipBoard.boardPart?.sticker?.text }}"
      [price]="ipBoardStockStickerPrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Sticker: {{ ipBoard.otherSideBoardPart?.sticker?.text }}"
      [price]="ipBoardOtherSideStockStickerPrice"
    ></tr>
    <tr
      facturation-row
      [divergentPricesOnly]="divergentPricesOnly"
      [baseProject]="baseProject"
      [distinctCompanyFactor]="distinctCompanyFactor"
      description="+ Aangepaste sticker"
      [price]="ipBoardCustomStickerPrice"
    ></tr>
  </ng-template>
  <tr
    facturation-row
    [divergentPricesOnly]="divergentPricesOnly"
    [baseProject]="baseProject"
    [distinctCompanyFactor]="distinctCompanyFactor"
    description="+ {{ ipBoard.extraBoard?.label }}:
    {{ ipBoard.extraBoardText | shortenText }}"
    [price]="ipBoardExtraBoardPrice"
  ></tr>
  <tr
    *ngIf="
      !divergentPricesOnly &&
      !baseProject.invoiceAsNonExecuted &&
      !project.collaborative &&
      (baseProject.projectPlacement.secondBoard | nullCheck)
    "
  >
    <td class="id"></td>
    <td class="date"></td>
    <td class="description">
      Tweede bord:
      <ng-container
        *ngIf="
          baseProject.projectPlacement.secondBoard.secondBoardCopy &&
          project.products?.length > 0
        "
      >
        {{
          project.products[0].boardPart?.boardType?.label
            | joiner
              : ' '
              : (project.products[0].boardPart?.placementType?.label
                  | lowercase)
        }}
      </ng-container>
      <ng-container
        *ngIf="!baseProject.projectPlacement.secondBoard.secondBoardCopy"
      >
        {{
          baseProject.projectPlacement.secondBoard.secondBoardConfiguration
            | shortenText
        }}
      </ng-container>
    </td>
    <td class="price">
      {{
        ipBoardPlacementPrice + ipBoardTotalPrice - secondBoardPlacementDiscount
          | multiply : distinctCompanyFactor
          | asFormatDecimal : true : 2
      }}
      €
    </td>
  </tr>
  <tr
    *ngIf="
      !project.collaborative &&
      !divergentPricesOnly &&
      !baseProject.invoiceAsNonExecuted &&
      (ipBoard.productPlacement?.arrows?.amountArrowsLeft > 0 ||
        ipBoard.productPlacement?.arrows?.amountArrowsRight > 0 ||
        ipBoard.arrows?.amountArrowsLeft > 0 ||
        ipBoard.arrows?.amountArrowsRight > 0)
    "
  >
    <td class="id"></td>
    <td class="date"></td>
    <td class="description">+ Pijlen</td>
    <td class="price">
      <ng-template
        let-arrowAmount="arrowAmount"
        [ngTemplateOutletContext]="{
          arrowAmount:
            ipBoard.arrows != null
              ? ((ipBoard.arrows.amountArrowsLeft != null
                  ? ipBoard.arrows.amountArrowsLeft
                  : 0) +
                  (ipBoard.arrows.amountArrowsRight != null
                    ? ipBoard.arrows.amountArrowsRight
                    : 0)) *
                11
              : ipBoard.productPlacement != null &&
                ipBoard.productPlacement.arrows != null
              ? ((ipBoard.productPlacement.arrows.amountArrowsLeft != null
                  ? ipBoard.productPlacement.arrows.amountArrowsLeft
                  : 0) +
                  (ipBoard.productPlacement.arrows.amountArrowsRight != null
                    ? ipBoard.productPlacement.arrows.amountArrowsRight
                    : 0)) *
                11
              : 0
        }"
        [ngTemplateOutlet]="arrows"
        #arrows
      >
        {{
          arrowAmount
            | multiply : distinctCompanyFactor
            | asFormatDecimal : true : 2
        }}
        €
      </ng-template>
    </td>
  </tr>
  <ng-container *ngIf="toShowPriceLines?.length > 0">
    <tr *ngFor="let priceLine of toShowPriceLines">
      <td class="id"></td>
      <td class="date"></td>
      <td class="description">{{ priceLine.text }}</td>
      <td class="price">
        {{ priceLine.price | asFormatDecimal : true : 2 }} €
      </td>
    </tr>
  </ng-container>
  <tr
    *ngIf="
      !divergentPricesOnly &&
      client &&
      baseProject.id == null &&
      !baseProject.invoiceAsNonExecuted &&
      !project.collaborative &&
      ipBoard.draftDesign
    "
  >
    <td class="id"></td>
    <td class="date"></td>
    <td class="description">+ Opmaak ontwerp</td>
    <td class="price">15,00 €</td>
  </tr>
  <tr
    *ngIf="
      !project.collaborative &&
      !divergentPricesOnly &&
      !baseProject.invoiceAsNonExecuted &&
      (ipBoard?.productPlacement?.extraHeight || ipBoard?.extraHeight)
    "
  >
    <td class="id"></td>
    <td class="date"></td>
    <td class="description">+ Hoger dan standaard hoogte plaatsen</td>
    <td class="price">15,00 €</td>
  </tr>
</ng-template>

<ng-template #emptyPrice>
  <td class="price"></td>
</ng-template>
